<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        router-link.button-previous.mr-2(to="/administracion/id/kpi-adherencia")
          i.fas.fa-chevron-left
        h1.m-0.d-inline-block.align-middle
          i Crear Kpi Adherencia
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_bg-gray.rounded-xl
            .card-body
              form.d-flex.flex-row.flex-wrap
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Nombre
                  input.col.form-control(type="text" v-model="name" maxlength='100' placeholder='ingresa nombre' title='ingresa tu nombre')
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Descripción
                  textarea.form-control(v-model="description" maxlength='100' rows="3" placeholder='ingresa descripción' title='Descripción')
                  .col-auto.form-group.align-items-center.mb-0.pr-0
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Meta
                  input.col.form-control(type="number" v-model="goal" maxlength='100' placeholder='0' max="100" title='Meta')                                                
                
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Roles
                  multiselect.col.px-0(
                    v-model="selectedMultiRole",
                    :options="todosMultiRole",
                    :multiple="true",
                    :close-on-select="false",
                    :clear-on-select="false",
                    :preserve-search="true",
                    placeholder="Seleccione Roles",
                    label="label",
                    track-by="value",
                    :preselect-first="false")

                //- .col-6.form-group.align-items-center.mb-4
                //-   label.font-weight-bold.col-3.pl-0.m-0 Viaje
                //-   multiselect.col.px-0(
                //-     v-model="selectedMultiTravel",
                //-     :options="todosMultiTravel",
                //-     :multiple="true",
                //-     :close-on-select="false",
                //-     :clear-on-select="false",
                //-     :preserve-search="true",
                //-     placeholder="Seleccione Viajes",
                //-     label="label",
                //-     track-by="value",
                //-     :preselect-first="false")

                //- .col-6.form-group.align-items-center.mb-4
                //-   label.font-weight-bold.col-3.pl-0.m-0 Segmento
                //-   multiselect.col.px-0(
                //-     v-model="selectedMultiSegment",
                //-     :options="todosMultiSegment",
                //-     :multiple="true",
                //-     :close-on-select="false",
                //-     :clear-on-select="false",
                //-     :preserve-search="true",
                //-     placeholder="Seleccione Segmentos",
                //-     label="label",
                //-     track-by="value",
                //-     :preselect-first="false")

                //- .col-6.form-group.align-items-center.mb-4
                //-   label.col-3.pl-0.m-0 Productos
                //-   multiselect.col.px-0(
                //-     v-model="selectedMultiProducts",
                //-     :options="todosMultiProducts",
                //-     :multiple="true",
                //-     :close-on-select="false",
                //-     :clear-on-select="false",
                //-     :preserve-search="true",
                //-     placeholder="Seleccione Productos",
                //-     label="label",
                //-     track-by="value",
                //-     :preselect-first="false")
                    
          .d-flex.flex-row.mt-5
            .col-auto.stepper-button.previous
              router-link(to="/administracion/id/kpi-adherencia")
                i.material-icons
                span Volver
            button.col-auto.stepper-button.next.ml-auto(@click="addKpiNegocio()")
              span Guardar
              i.material-icons


</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions } from 'vuex';
import { nullLiteralTypeAnnotation } from 'babel-types';
export default {
  name: 'AdministracionKpiCreate',
  components: {
     Multiselect
  },
  data () {
    return {
      name: null,
      description: null,
      goal: null,
      kpipercentage: null,
      selectedMultiRole: [],
      todosMultiRole: [],
      selectedMultiTravel: [],
      todosMultiTravel: [],
      selectedMultiSegment: [],
      todosMultiSegment: [],
      selectedMultiProducts: [],
      todosMultiProducts: []
    }
  },
  methods: {
    ...mapActions('user', [
      'insertUser',
      'getUsers',
      'getRoles'
    ]),
    ...mapActions('kpi', [
      'createKpi'
    ]),
    ...mapActions('travel', [
      'travelList'
    ]),
    ...mapActions('segment', [
      'ByTravelIds', 'segmentList'
    ]),
    ...mapActions('product', [
      'BySegmentIds', 'productList'
    ]),
    getValuesOfMultiSelect(valuesMultiSelect) {
      return valuesMultiSelect.map(values => values.value)
    },
    getItemsToMultiSelectLoad(items) {
      return items.map(p => ({value: p.id, label: p.name, profile: p.profilename, leader: p.leader}))
    },
    getSegmentsToMultiSelectLoad(items) {
      return items.map(p => ({value: p.id, label: `${p.name} (${p.travel.name})`, profile: p.profilename, leader: p.leader}))
    },
    getProductsToMultiSelectLoad(items) {
      return items.map(p => ({value: p.id, label: `${p.name} (${p.segment.name}/${p.segment.travel.name})`, profile: p.profilename, leader: p.leader}))
    },
    getSelectedAfterChangedParent(todos, oldSelectedItems) {
      return todos.filter(t => oldSelectedItems.map(o => o.value).includes(t.value))
    },
    getKpiFromProps() {
      const vm = this
      return {
        name: vm.name,
        description: vm.description,
        goal: vm.goal,
        kpipercentage: vm.kpipercentage,
        role: vm.getValuesOfMultiSelect(vm.selectedMultiRole),
        travel: vm.getValuesOfMultiSelect(vm.selectedMultiTravel),
        segment: vm.getValuesOfMultiSelect(vm.selectedMultiSegment),
        product: vm.getValuesOfMultiSelect(vm.selectedMultiProducts)      
      }
    },
    loadControls() {
      const vm = this
      const loading = vm.$toast.loading('Cargando ...')
      vm.loadRole()
      vm.loadTravels()
      vm.getSegments()
      vm.getProducts()
      loading.hide()
    },
    loadRole() {
      const vm = this
      vm.getRoles({}).then(response => {
        vm.todosMultiRole = vm.getItemsToMultiSelectLoad(response)
      })
    },
    loadTravels() {
      const vm = this
      vm.travelList({}).then(response => {
        vm.todosMultiTravel = vm.getItemsToMultiSelectLoad(response)        
      })
    },
    getSegments($event) {
      const vm = this
      // const selectedValues = vm.getValuesOfMultiSelect(vm.selectedMultiTravel)
      // if (vm.selectedTravel) {
        vm.segmentList({}).then(response => {
          vm.todosMultiSegment = vm.getSegmentsToMultiSelectLoad(response)          
        }, (error) => {
          vm.notify(error)
        })
      // }
    },
    getProducts($event) {
      const vm = this
      // if (vm.selectedSegment) {
        vm.productList({ids: null}).then(response => {
          vm.todosMultiProducts = vm.getProductsToMultiSelectLoad(response)
          vm.selectedMultiProducts = vm.getSelectedAfterChangedParent(vm.selectedMultiProducts, vm.todosMultiProducts)
        }, (error) => {
          vm.notify(error)
        })
      // }
    },
    notify(error = true, message) {
      const vm = this
      vm.$notify({
          type: error ? 'danger' : 'success',
          title: 'Notificación',
          content: message,
          closeable: true,
          duration: 5000
        })
    },
    clearInputs() {
      const vm = this
      vm.name = ''
      vm.description = ''
      vm.goal = ''
      vm.kpipercentage = ''
      vm.selectedMultiRole = []
    },
    addKpiNegocio() {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      if (vm.validate()) {
        const data = vm.getKpiFromProps()
        vm.createKpi(data).then(result => {
          loading.hide()
          // vm.clearInputs()
          vm.notify(false, 'Kpi Adherencia creado')
        }).catch(error => {
          loading.hide()
          vm.notify(true, error.payload.message)
        })
      } else {
        loading.hide()
      }
    },
    isValidInput(input) {
      return input !== undefined && input !== null && input.length > 0
    },
    isValidInputPer(input) {
      return input >= 0 && input <= 100
    },
    validate() {
      const vm = this
      let valid = true
      let missing = ''
      
      if (!vm.isValidInput(vm.name)) {
        missing = 'Debe completar el campo nombre'
        valid = false
      } else if (!vm.isValidInput(vm.description)) {
        missing = 'Debe completar el campo descripción'
        valid = false
      } else if (!vm.isValidInputPer(vm.goal)) {
        missing = 'Debe completar el campo meta o fuera de rango'
        valid = false
      } else if (!vm.isValidInputPer(vm.kpipercentage)) {
        missing = 'Debe completar el campo % kpi o fuera de rango'
        valid = false
      } else if (!vm.isValidInput(vm.selectedMultiRole)) {
        missing = 'Debe completar el campo role.'
        valid = false
      }

      if (valid) {
        return true
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: missing,
          closeable: true,
          duration: 5000
        })
        return false
      }
    }
  },
  mounted() {
    const vm = this;
    vm.loadControls()
    this.$emit('can-continue', { value: true })
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/administracion-kpi-create.vue